/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  EvolveForm,
  EvolveForm$Outbound,
  EvolveForm$outboundSchema,
} from "../components/evolveform.js";

export type EvolveDeploymentSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type EvolveDeploymentSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type EvolveDeploymentSecurity = {
  option1?: EvolveDeploymentSecurityOption1 | undefined;
  option2?: EvolveDeploymentSecurityOption2 | undefined;
};

export type EvolveDeploymentRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  evolveForm: EvolveForm;
};

/** @internal */
export type EvolveDeploymentSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const EvolveDeploymentSecurityOption1$outboundSchema: z.ZodMiniType<
  EvolveDeploymentSecurityOption1$Outbound,
  EvolveDeploymentSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function evolveDeploymentSecurityOption1ToJSON(
  evolveDeploymentSecurityOption1: EvolveDeploymentSecurityOption1,
): string {
  return JSON.stringify(
    EvolveDeploymentSecurityOption1$outboundSchema.parse(
      evolveDeploymentSecurityOption1,
    ),
  );
}

/** @internal */
export type EvolveDeploymentSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const EvolveDeploymentSecurityOption2$outboundSchema: z.ZodMiniType<
  EvolveDeploymentSecurityOption2$Outbound,
  EvolveDeploymentSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function evolveDeploymentSecurityOption2ToJSON(
  evolveDeploymentSecurityOption2: EvolveDeploymentSecurityOption2,
): string {
  return JSON.stringify(
    EvolveDeploymentSecurityOption2$outboundSchema.parse(
      evolveDeploymentSecurityOption2,
    ),
  );
}

/** @internal */
export type EvolveDeploymentSecurity$Outbound = {
  Option1?: EvolveDeploymentSecurityOption1$Outbound | undefined;
  Option2?: EvolveDeploymentSecurityOption2$Outbound | undefined;
};

/** @internal */
export const EvolveDeploymentSecurity$outboundSchema: z.ZodMiniType<
  EvolveDeploymentSecurity$Outbound,
  EvolveDeploymentSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => EvolveDeploymentSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => EvolveDeploymentSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function evolveDeploymentSecurityToJSON(
  evolveDeploymentSecurity: EvolveDeploymentSecurity,
): string {
  return JSON.stringify(
    EvolveDeploymentSecurity$outboundSchema.parse(evolveDeploymentSecurity),
  );
}

/** @internal */
export type EvolveDeploymentRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  EvolveForm: EvolveForm$Outbound;
};

/** @internal */
export const EvolveDeploymentRequest$outboundSchema: z.ZodMiniType<
  EvolveDeploymentRequest$Outbound,
  EvolveDeploymentRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    evolveForm: EvolveForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      evolveForm: "EvolveForm",
    });
  }),
);

export function evolveDeploymentRequestToJSON(
  evolveDeploymentRequest: EvolveDeploymentRequest,
): string {
  return JSON.stringify(
    EvolveDeploymentRequest$outboundSchema.parse(evolveDeploymentRequest),
  );
}
